import React, { useEffect, useState } from "react";
import { Table, Container, Form, Row, Col, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Preloader from "../../shared/PreLoaders";
import "./Cashbook.css";
import {
  fetchCircles,
  fetchDivisionsByCircle,
  fetchRangesByDivision,
  fetchVfcByRange,
  fetchTransactions,
  fetchLoansByVfcAndDate,
  fetchLoansCollectionByVfc,
  fetchOpeningBalance,
  formatDate,
  handleEndOfBusiness,
} from "./CahbookFunction";

const Cashbook = () => {
  const [circleData, setCircleData] = useState([]);
  const [divisionData, setDivisionData] = useState([]);
  const [rangeData, setRangeData] = useState([]);
  const [vfcData, setVfcData] = useState([]);

  const [selectedCircle, setSelectedCircle] = useState("");
  const [selectedDivision, setSelectedDivision] = useState("");
  const [selectedRange, setSelectedRange] = useState("");
  const [selectedVfcId, setSelectedVfcId] = useState("");
  const [selectDate, setSelectDate] = useState(null);

  const [incomeTransactions, setIncomeTransactions] = useState([]);
  const [expenseTransactions, setExpenseTransactions] = useState([]);
  const [openingBalance, setOpeningBalance] = useState({ cash: 0, bank: 0 });
  const [closingBalance, setClosingBalance] = useState({ cash: 0, bank: 0 });
  const [incomeCashTotal, setIncomeCashTotal] = useState(0);
  const [incomeBankTotal, setIncomeBankTotal] = useState(0);
  const [expenseCashTotal, setExpenseCashTotal] = useState(0);
  const [expenseBankTotal, setExpenseBankTotal] = useState(0);
  const [loanRepaymentCashTotal, setLoanRepaymentCashTotal] = useState(0);
  const [loanRepaymentBankTotal, setLoanRepaymentBankTotal] = useState(0);
  const [loanCashTotal, setLoanCashTotal] = useState(0);
  const [loanBankTotal, setLoanBankTotal] = useState(0);

  const [loanData, setLoanData] = useState([]);
  const [loanDetails, setLoanDetails] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const Api = process.env.REACT_APP_API;

  useEffect(() => {
    fetchCircles(Api, setCircleData, setLoading);
  }, []);

  const handleViewCashbook = async () => {
    if (!selectedVfcId || !selectDate) {
      setError("Please select both VFC and Date");
      return;
    }
    setError(null);
    setLoading(true);

    await fetchTransactions(
      Api,
      selectedVfcId,
      selectDate,
      (data) => {
        const income = data.filter((txn) => txn.type === "R");
        const expense = data.filter((txn) => txn.type === "P");
        setIncomeTransactions(income);
        setExpenseTransactions(expense);

        const incomeCash = income.reduce(
          (acc, txn) => (txn.cashOrBank === "cash" ? acc + txn.amount : acc),
          0
        );
        const incomeBank = income.reduce(
          (acc, txn) => (txn.cashOrBank === "bank" ? acc + txn.amount : acc),
          0
        );
        const expenseCash = expense.reduce(
          (acc, txn) => (txn.cashOrBank === "cash" ? acc + txn.amount : acc),
          0
        );
        const expenseBank = expense.reduce(
          (acc, txn) => (txn.cashOrBank === "bank" ? acc + txn.amount : acc),
          0
        );

        setIncomeCashTotal(incomeCash);
        setIncomeBankTotal(incomeBank);
        setExpenseCashTotal(expenseCash);
        setExpenseBankTotal(expenseBank);
      },
      setError,
      setLoading
    );

    // Fetch Opening Balance
    await fetchOpeningBalance(
      Api,
      selectedVfcId,
      selectDate,
      setOpeningBalance,
      setError,
      setLoading
    );

    // let loanCashTotal = 0;
    // let loanBankTotal = 0;
    // let loanRepaymentCashTotal = 0;
    // let loanRepaymentBankTotal = 0;

    await fetchLoansByVfcAndDate(
      Api,
      selectedVfcId,
      selectDate,
      (loans) => {
        setLoanData(loans);

        const loanCashTotal = loans.reduce(
          (acc, loan) => (loan.cashOrBank === "cash" ? acc + loan.amount : acc),
          0
        );
        const loanBankTotal = loans.reduce(
          (acc, loan) => (loan.cashOrBank === "bank" ? acc + loan.amount : acc),
          0
        );

        setLoanCashTotal(loanCashTotal);
        setLoanBankTotal(loanBankTotal);
      },
      setLoading,
      setError
    );

    await fetchLoansCollectionByVfc(
      Api,
      selectedVfcId,
      selectDate,
      (repayments) => {
        setLoanDetails(repayments);

        const loanRepaymentCashTotal = repayments.reduce(
          (acc, repay) =>
            repay.cashOrBank === "cash" ? acc + repay.amountPaid : acc,
          0
        );
        const loanRepaymentBankTotal = repayments.reduce(
          (acc, repay) =>
            repay.cashOrBank === "bank" ? acc + repay.amountPaid : acc,
          0
        );
        setLoanRepaymentCashTotal(loanRepaymentCashTotal);
        setLoanRepaymentBankTotal(loanRepaymentBankTotal);
      },
      setLoading,
      setError
    );

    //Calculate Final Closing Balance
    setClosingBalance({
      cash:
        openingBalance.cash +
        incomeCashTotal -
        expenseCashTotal -
        loanCashTotal +
        loanRepaymentCashTotal,
      bank:
        openingBalance.bank +
        incomeBankTotal -
        expenseBankTotal -
        loanBankTotal +
        loanRepaymentBankTotal,
    });

    // setClosingBalance({
    //   cash:
    //     openingBalance.cash +
    //     incomeCashTotal +
    //     loanCashTotal -
    //     (expenseCashTotal + loanRepaymentCashTotal),
    //   bank:
    //     openingBalance.bank +
    //     incomeBankTotal +
    //     loanBankTotal -
    //     (expenseBankTotal + loanRepaymentBankTotal),
    // });
    setLoading(false);
  };

  const totalRows = Math.max(
    incomeTransactions.length,
    expenseTransactions.length
  );

  return (
    <div>
      <Preloader loading={loading} />
      <div className="page-header">
        <h3 className="page-title"> Cashbook </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(e) => e.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Cashbook
            </li>
          </ol>
        </nav>
      </div>

      <Container>
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <Row>
                <Col>
                  <Form.Group controlId="circle">
                    <Form.Label>Select Circle</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedCircle}
                      onChange={(e) => {
                        const circleId = e.target.value;
                        setSelectedCircle(circleId);
                        fetchDivisionsByCircle(
                          Api,
                          circleId,

                          setDivisionData,
                          setLoading
                        );
                      }}
                    >
                      <option>Select Circle</option>
                      {circleData.map((circle) => (
                        <option key={circle._id} value={circle._id}>
                          {circle.circleName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="division">
                    <Form.Label>Select Division</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedDivision}
                      onChange={(e) => {
                        const divisionId = e.target.value;
                        setSelectedDivision(divisionId);
                        fetchRangesByDivision(
                          Api,
                          divisionId,

                          setRangeData,
                          setLoading
                        );
                      }}
                    >
                      <option>Select Division</option>
                      {divisionData.map((division) => (
                        <option key={division._id} value={division._id}>
                          {division.divisionName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="range">
                    <Form.Label>Select Range</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedRange}
                      onChange={(e) => {
                        const rangeId = e.target.value;
                        setSelectedRange(rangeId);
                        fetchVfcByRange(
                          Api,
                          rangeId,

                          setVfcData,
                          setLoading
                        );
                      }}
                    >
                      <option>Select Range</option>
                      {rangeData.map((range) => (
                        <option key={range._id} value={range._id}>
                          {range.rangeName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col>
                  <Form.Group controlId="VFC">
                    <Form.Label>Select VFC</Form.Label>
                    <Form.Control
                      as="select"
                      value={selectedVfcId}
                      onChange={(e) => setSelectedVfcId(e.target.value)}
                    >
                      <option>Select VFC</option>
                      {vfcData.map((vfc) => (
                        <option key={vfc._id} value={vfc._id}>
                          {vfc.vfcName}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        <Row className="mt-3">
          <Col>
            <DatePicker
              selected={selectDate}
              onChange={(date) => setSelectDate(formatDate(date))}
              dateFormat="dd/MM/yyyy"
              customInput={<CustomInput />}
            />
          </Col>

          <Col>
            <Button variant="outline-primary" onClick={handleViewCashbook}>
              <i className="mdi mdi-file-check btn-icon-prepend"></i> View
              Cashbook
            </Button>
          </Col>
          <Col>
            <Button
              variant="outline-danger"
              className="btn-icon-text"
              onClick={() =>
                handleEndOfBusiness(
                  Api,
                  selectedVfcId,
                  selectDate,
                  closingBalance,
                  setError,
                  setLoading,
                  () => {
                    alert("End of Business recorded successfully!");
                    setIncomeTransactions([]);
                    setExpenseTransactions([]);
                    setOpeningBalance({ cash: 0, bank: 0 });
                    setClosingBalance({ cash: 0, bank: 0 });
                    setSelectDate(null);
                    setSelectedVfcId("");
                  }
                )
              }
            >
              <i className="mdi mdi-upload btn-icon-prepend"></i>
              End of Business
            </Button>
          </Col>
        </Row>

        {error && <div style={{ color: "red" }}>{error}</div>}
        {selectDate && selectedVfcId && (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="Table_data">
                  <Table bordered className="cashbook-table">
                    <thead>
                      <tr>
                        <th colSpan="2">Sl.No</th>
                        <th>Particulars</th>
                        <th>Cash</th>
                        <th>Bank</th>
                        <th colSpan="2">Sl.No</th>
                        <th>Particulars</th>
                        <th>Cash</th>
                        <th>Bank</th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Opening Balance Row */}
                      <tr>
                        <td colSpan="2">1</td>
                        <td style={{ color: "red" }}>Opening Balance</td>
                        <td style={{ color: "red" }}>{openingBalance.cash}</td>
                        <td style={{ color: "red" }}>{openingBalance.bank}</td>
                        <td colSpan="2">1</td>
                        <td>
                          {expenseTransactions.length > 0
                            ? expenseTransactions[0]?.voucherType
                                ?.voucherName || "N/A"
                            : "Opening Balance"}
                        </td>
                        <td>
                          {expenseTransactions[0]?.cashOrBank === "cash"
                            ? expenseTransactions[0]?.amount
                            : ""}
                        </td>
                        <td>
                          {expenseTransactions[0]?.cashOrBank === "bank"
                            ? expenseTransactions[0]?.amount
                            : ""}
                        </td>
                      </tr>

                      {/* Show Transactions + Loans Together */}
                      {Array.from({
                        length: Math.max(
                          incomeTransactions.length,
                          expenseTransactions.length,
                          loanData.length,
                          loanDetails.length
                        ),
                      }).map((_, i) => (
                        <tr key={i}>
                          {/* Income Side (Transactions + Loan Repayment) */}
                          <td colSpan="2">{i + 2}</td>
                          <td>
                            {incomeTransactions[i]?.voucherType?.voucherName ||
                              (loanDetails[i]?.loanId
                                ? "Loan Repayment"
                                : "N/A")}
                          </td>
                          <td>
                            {incomeTransactions[i]?.cashOrBank === "cash"
                              ? incomeTransactions[i]?.amount
                              : loanDetails[i]?.cashOrBank === "cash"
                              ? loanDetails[i]?.amountPaid
                              : ""}
                          </td>
                          <td>
                            {incomeTransactions[i]?.cashOrBank === "bank"
                              ? incomeTransactions[i]?.amount
                              : loanDetails[i]?.cashOrBank === "bank"
                              ? loanDetails[i]?.amountPaid
                              : ""}
                          </td>

                          {/* Expense Side (Transactions + Loan Disbursement) */}
                          <td colSpan="2">{i + 2}</td>
                          <td>
                            {expenseTransactions[i]?.voucherType?.voucherName ||
                              (loanData[i]?.loanNo
                                ? "Loan Disbursement"
                                : "N/A")}
                          </td>
                          <td>
                            {expenseTransactions[i]?.cashOrBank === "cash"
                              ? expenseTransactions[i]?.amount
                              : loanData[i]?.cashOrBank === "cash"
                              ? loanData[i]?.amount
                              : ""}
                          </td>
                          <td>
                            {expenseTransactions[i]?.cashOrBank === "bank"
                              ? expenseTransactions[i]?.amount
                              : loanData[i]?.cashOrBank === "bank"
                              ? loanData[i]?.amount
                              : ""}
                          </td>
                        </tr>
                      ))}

                      {/* Closing Balance */}
                      <tr style={{ color: "red" }}>
                        <td colSpan="2"></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td colSpan="2">Closing Balance</td>
                        <td>{closingBalance.cash}</td>
                        <td>{closingBalance.bank}</td>
                      </tr>

                      {/* Totals */}
                      <tr style={{ fontWeight: "bold" }}>
                        <td></td>
                        <td colSpan="2">Total</td>
                        <td>{incomeCashTotal + openingBalance.cash}</td>
                        <td>{incomeBankTotal + openingBalance.bank}</td>
                        <td></td>
                        <td colSpan="2">Total</td>
                        <td>{expenseCashTotal + closingBalance.cash}</td>
                        <td>{expenseBankTotal + closingBalance.bank}</td>
                      </tr>

                      {/* Final Income/Expense Total */}
                      <tr style={{ fontWeight: "bold" }}>
                        <td></td>
                        <td colSpan="2">Income Total</td>
                        <td>{incomeCashTotal}</td>
                        <td>{incomeBankTotal}</td>
                        <td></td>
                        <td colSpan="2">Expense Total</td>
                        <td>{expenseCashTotal}</td>
                        <td>{expenseBankTotal}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </div>
  );
};

const CustomInput = ({ value, onClick }) => (
  <button className="calendar-button" onClick={onClick}>
    {value || "Select Date"}
  </button>
);

export default Cashbook;
